<template>
  <div>
    <header class="no_logo">
      <!--<Header msg="Header" />-->
      <SettingsHeader msg="SettingsHeader" />
    </header>
    <main>
      <div class="storeinfo container flex_top flex_wrap">
        <div class="cover">
          <div class="store_img owl-carousel owl-theme">
            <div class="item">
              <img :src="shop.image ? shop.image : defaultImage" />
            </div>
          </div>
          <div v-if="!shop.isEnabled" class="cover_mask flex_center">
            暫不供應
          </div>
          <!-- <time><b>30</b>分鐘</time> -->
          <div class="store_img_num"></div>
        </div>
        <!-- <div class="cover">
          <img :src="shop.image ? shop.image : defaultImage" />
          <div v-if="!shop.isEnabled" class="cover_mask flex_center">
            暫不供應
          </div>
          <time><b>30</b>分鐘</time>
        </div> -->
        <div class="title">
          <div class="name">{{ shop.name }}</div>
          <!-- <div class="comment"><i class="icon-star"></i> 4.5</div> -->
        </div>
        <div class="focus">
          <div
            v-if="shop.shopCategory !== 'retail'"
            :class="['status', shop.isEnabled ? '' : 'stop-open']"
          >
            {{ shop.isEnabled ? "" : "暫不供應" }}
          </div>
          <!-- <a class="share" href="#share" rel="modal:open"
            ><i class="icon-share"></i>分享</a
          >

          <div id="share" class="sharebox modal">
            <div class="flex_center">
              <a class="btn copylink" href="#"
                ><i class="icon-link"></i>複製連結</a
              >
              <a class="btn line" href="#"
                ><i class="icon-line"></i>分享LINE好友</a
              >
            </div>
          </div> -->
        </div>
        <div class="info">
          <!-- <div class="tel flex_center">
            <i v-if="shop.phone" class="icon-phone"></i
            ><a :href="'tel:' + shop.phone">{{ shop.phone }}</a>
          </div> -->
          <div class="add flex_center">
            <i class="icon-location"></i
            ><a
              target="_blank"
              v-on:click="
                openLink(
                  'https://www.google.com/maps/search/?api=1&query=' +
                    encodeURI(shop.address)
                )
              "
            >
              {{ shop.address }}
            </a>
          </div>
        </div>
        <div v-if="shop.info" class="biz_hours flex_top">
          營業資訊：
          <div v-html="shop.info">{{ shop.info }}</div>
          <!-- <div>週一至週五 10:00-20:00<br />週六日 09:00-23:00</div> -->
        </div>
        <div class="iconbar">
          <div v-if="shop.shopCategory === 'retail'" class="pick">
            取餐方式：
            <i v-if="shop.isDelivery" class="icon_freight">宅配</i>
            <i v-if="shop.isTakeout" class="icon_hospital">院內送</i>
            <i v-if="shop.isEatIn" class="icon_inside">自取</i>
          </div>
          <div v-else class="pick">
            取餐方式：
            <i v-if="shop.isDelivery" class="icon_delivery">送</i>
            <i v-if="shop.isTakeout" class="icon_self">自</i>
            <i v-if="shop.isEatIn" class="icon_inside">內</i>
          </div>
          <div class="pay">
            付款方式：
            <i
              v-if="shop.isMobilePayment && shop.payMethods.linepay"
              class="icon_linepay"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.googlepay"
              class="icon_googlepay"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.applepay"
              class="icon_applepay"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.credit"
              class="icon_creditcard"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.easywallet"
              class="icon_easywallet"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.taiwanpay"
              class="icon_taiwanpay"
            ></i>
              <i
              v-if="shop.isMobilePayment && shop.payMethods.jkopay"
              class="icon_jkopay"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.icashpay"
              class="icon_icash"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.pxpay"
              class="icon_pxpay"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.pxpayplus"
              class="icon_pxpay"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.pluspay"
              class="icon_pluspay"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.twqr"
              class="icon_twqr"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.aftee"
              class="icon_aftee"
            ></i>
            <i v-if="shop.isCash" class="icon_cash"></i>
          </div>
        </div>

        <!-- 若有已點過狀態，則顯示button: 已點清單/前往結帳 -->
        <div v-if="qrInfo && qrInfo.listUrl" class="buttonbar flex_center">
          <a class="ordered" :href="qrInfo.listUrl">已點清單</a>
          <!-- <a class="gotopay" :href="qrInfo.listUrl">前往結帳</a> -->
        </div>

        <!-- 熱銷商品 -->
        <div v-if="products && products.length" class="hot_sale">
          <h4>熱銷商品</h4>
          <div class="container flex_center">
            <div v-for="(p, index) in products" class="item">
              <div class="pt_img"><img v-if="p.image" :src="p.image" /></div>
              <div class="name">{{ p.name }}</div>
              <div class="price">
                $<b>{{ p.price }}</b
                >
              </div>
              <div class="rank">{{ index + 1 }}</div>
            </div>
          </div>
        </div>

        <!-- <div class="order_btn">
          <a v-if="shop.portalLinkType !== 'line'" :href="shop.link"
            >我要{{ shop.shopCategory === "retail" ? "買東西" : "點餐"
            }}<i class="icon-arrow-right"></i
          ></a>
          <a v-if="shop.portalLinkType === 'line'" :href="shop.link"
            >加LINE好友．線上逛<i class="icon-arrow-right"></i
          ></a>
        </div> -->

        <div v-if="type !== 'QrShop' && type !== 'LineShop'" class="order_btn">
          <a v-if="shop.portalLinkType === 'web'" :href="shop.webLink"
            >我要{{ shop.shopCategory === "retail" ? "買東西" : "點餐"
            }}<i class="icon-arrow-right"></i
          ></a>
          <a v-else-if="shop.portalLinkType === 'line' && shop.link" :href="shop.link"
            >加LINE好友．線上逛<i class="icon-arrow-right"></i
          ></a>

          <a v-else-if="shop.link" :href="shop.link"
            >我要{{ shop.shopCategory === "retail" ? "買東西" : "點餐"
            }}<i class="icon-arrow-right"></i
          ></a>
        </div>
      </div>
      <!-- END .storeinfo -->
    </main>
    <footer>
      <div v-if="type === 'QrShop'" class="order_btn">
        <!-- web掃碼點餐 -->
        <a :href="qrInfo && qrInfo.menuUrl"
          >我要{{ shop.shopCategory === "retail" ? "買東西" : "點餐"
          }}<i class="icon-arrow-right"></i
        ></a>
      </div>
      <div v-else class="order_btn">
        <a v-if="shop.portalLinkType !== 'line' && shop.link && !shop.hideLink" :href="shop.link"
          >我要{{ shop.shopCategory === "retail" ? "買東西" : "點餐"
          }}<i class="icon-arrow-right"></i
        ></a>
        <a v-if="shop.portalLinkType === 'line' && shop.link" :href="shop.link"
          >加LINE好友．線上逛<i class="icon-arrow-right"></i
        ></a>
      </div>

      <!-- 單店沒有footer才會show -->
      <!-- BUG: 這邊是不是要改看bcsAppId才對? -->
      <div
        v-if="type === 'LineShop' && shop.ssoAppId && shop.ssoImage"
        :class="['notify_fixed', 'member_push']"
      >
        <div class="container">
          <!-- <a href="#"><img src="/images/member_push.png"/></a> -->
          <!-- <a href="#"><img src="/images/staff_binding.png"/></a> -->

          <a v-on:click="openPage(shop.ssoUrl)">
            <img :src="shop.ssoImage" />
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src

// 不顯示Header會有個問題，因為changeDefault language to tw是在header寫..所以這個頁面要另外寫一次 (this.changeLanguage("tw"); )
// import Header from "@/components/Header.vue";
import SettingsHeader from "@/components/SettingsHeader.vue";
import apis from "@/services/apis";

export default {
  name: "home",
  data() {
    return {
      shop: {},
      qrInfo: {},
      defaultImage: GLOBAL_DEFAULT_SHOP_IMG,
      products: [],
    };
  },
  props: ["type"],
  components: {
    // Header,
    SettingsHeader,
  },
  methods: {
    openPage(link) {
      // let self = this;
      // if (this.type === "portal") {
      //   this.$router.push({
      //     path: link,
      //     // query: this.$router.currentRoute.query,
      //   });
      // } else {

      // }
      window.open(link, "_blank");
    },
    gotoPage(path) {
      this.$router.push({
        path: path,
        query: this.$router.currentRoute.query,
      });
    },
    getQrInfo() {
      return apis.getQrInfo(this.$router.currentRoute.query.q);
    },
    getShopInfo() {
      return apis.getShopInfo(
        this.$router.currentRoute.params.shopId ||
          this.$router.currentRoute.query.s
      );
    },
    getTopProducts() {
      return apis.getTopProducts(
        this.$router.currentRoute.params.shopId ||
          this.$router.currentRoute.query.s
      );
    },
    getPortalConfig() {
      return apis.getPortalInfo(this.$router.currentRoute.query.p);
    },
    changeLanguage(lang) {
      this.language = lang;
      // lang: this.$store.state.lang, // get lang 預設值 `en`
      this.$i18n.locale = lang;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    owlTrigger() {
      // 多圖輪播
      if ($(".store_img").length > 0) {
        //顯示當前數字和總數
        var owl = $(".store_img");
        owl.on("changed.owl.carousel", function(e) {
          if (!e.namespace) {
            return;
          }
          var carousel = e.relatedTarget;
          $(".store_img_num").text(
            carousel.relative(carousel.current()) +
              1 +
              "/" +
              carousel.items().length
          );
        });

        if (typeof owl.owlCarousel === "function") {
          owl.owlCarousel({
            items: 1,
            margin: 0,
            loop: false,
            lazyLoad: false,
            autoHeight: false,
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 5000,
            animateOut: "fadeOut",
            animateIn: "fadeIn",
            nav: false,
          });

          // 要觸發這一次先wordaround掉autoHeight 1px issue
          setTimeout(function() {
            owl.trigger("refresh.owl.carousel");
            // owl.trigger('next.owl.carousel');
          }, 500);
        }
      }
    },
  },
  created() {
    this.changeLanguage("tw");
  },
  mounted() {
    let self = this;
    window.onload = function() {
      self.owlTrigger();
    };

    self.owlTrigger();

    // console.info("App this router:", this.$router);
    // console.info("App currentRoute:", this.$router.currentRoute);

    let tasks = [
      this.getPortalConfig(),
      this.getShopInfo(),
      // this.getTopProducts(), // Top6可能要比較久，其他資訊先抓這個最晚抓
    ];

    if (self.$router.currentRoute.query.q) {
      tasks.push(this.getQrInfo());
    }
    Promise.all(tasks).then((responses) => {
      let portal = responses[0];
      let shop = responses[1];
      // self.products = responses[2];

      // self.qrInfo = responses[3] || {};
      self.qrInfo = responses[2] || {};

      if (self.qrInfo.orderUrl) { // 已經結帳了
        window.location.href = self.qrInfo.orderUrl;
      }

      console.log("the portal " + JSON.stringify(portal));
      shop.payMethods = {
        linepay: true,
        applepay: true,
        googlepay: true,
        credit: true,
        easywallet: false,
        jkopay: false,
        taiwanpay: false
      };
      if (
        shop.isMobilePayment &&
        shop.paymentOptions &&
        shop.paymentOptions.methods
      ) {
        // 有限制顯示的支付方式
        shop.payMethods = {};

        for (let p = 0; p < shop.paymentOptions.methods.length; ++p) {
          shop.payMethods[shop.paymentOptions.methods[p]] = true;
        }
      }

      // 幫shop 加上source
      if (portal.linkType === "OA") shop.portalLinkType = "line";
      else if (portal.linkType === "WEB") shop.portalLinkType = "web";

      if (shop && shop.link && shop.portalLinkType !== "line") {
        if ((this.type === 'LineShop' && navigator.userAgent.indexOf("Line") > -1)) {  // 用LINE的瀏覽器開的話，都要求開OA
          shop.link = shop.lineAddFriendUrl;
          // 可能有點混淆，把按鈕拿掉
          shop.hideLink = true;
        } else {
          shop.link += "&source=" + self.$router.currentRoute.query.p;
        }
      } else {
        shop.link = shop.lineAddFriendUrl;
      }

      if (shop.ssoAppId) shop.ssoUrl = "/bcs?app=" + shop.ssoAppId;

      if (shop.info) {
        var shopInfo = shop.info.replace(/\n/g,"<br>");
        shop.info = shopInfo;
      }
      
      this.shop = shop;
    });

    this.getTopProducts().then((products) => {
      self.products = products;
    })
    // this.getPortalConfig().then((shop) => {
    //   // 幫shop 加上source
    //   if (shop && shop.link && shop.portalLinkType !== "line") {
    //     shop.link += "&source=" + self.$router.currentRoute.query.p;
    //   } else {
    //     shop.link = shop.lineAddFriendUrl;
    //   }

    //   this.shop = shop;
    // });

    // this.getShopInfo().then((shop) => {
    //   // 幫shop 加上source
    //   if (shop && shop.link && shop.portalLinkType !== "line") {
    //     shop.link += "&source=" + self.$router.currentRoute.query.p;
    //   } else {
    //     shop.link = shop.lineAddFriendUrl;
    //   }

    //   this.shop = shop;
    // });
  },
};
</script>
